@if (frame && frame[field] !== undefined) {
<div class="panel">
	<div class="heading">{{ label }}</div>
	<div class="content value">
		<span>{{ frame[field] | number:'1.2-2' }}</span>
		<span class="units">{{ units }}</span>
	</div>
</div>
}